import {PrintData} from "./print-data";
import {urlToJson} from "./url-to-json";
import {qzManager} from "../../../../classes/printer-manager";


/**
 * (ZPL) 송장 출력데이터
 */
export default new PrintData({
    id: '',
    desc: 'ZPL방식 송장출력',

    makeQzDataPromise: async (house_id, blno) => {
        let ver = await qzManager.getVersion();
        let url = `/houses/${house_id}/bl?print_manager=yes&qz_ver=${ver}`;
        if (blno) {
            url += `blno=${blno}`;
        }

        return urlToJson(url)
            .then((res) => {
                return new Promise((resolve, reject) => {

                    // 송장 여러장 오면 여러장 모두 배열에 담아전달
                    // 담긴만큼 여러장 모두 출력됨.
                    let data = [];
                    res.zpls.forEach((zpl) => {
                        data.push(...zpl);
                    });
                    resolve(data);
                    console.log('zpl 송장 데이터 생성완료!');

                });
            });


    },
})